module.exports = __webpack_public_path__ + "static/media/ph_beaker_3.b1c2cbec.svg";